<template>
    <div class="auth-pin">
        <div class="form-group">
            <div class="input-group">
                <span class="input-group-text" :class="classes('input')">#</span>
                <input type="text" ref="pin" required class="form-control" v-model="value" :class="classes('input')"
                    :placeholder="trans('auth.pin_number')" />
            </div>
            <div class="invalid-feedback"></div>
        </div>
        <div class="form-group small text--color-muted" v-if="!requested">
            {{ trans('auth.didnotreceivepin') }}, <a href="javascript:void(0)" class="text-muted" @click="request()">{{
                trans('auth.requestithere') }}</a>.
        </div>
    </div>
</template>

<script>
import store from '../../store'

export default {
    emits: ['update:pin', 'update:section', 'request:pin'],
    props: {
        pin: { type: String, required: true },
        section: { type: String, required: true },
    },
    computed: {
        value: {
            get() { return this.pin },
            set(v) { this.$emit('update:pin', v) }
        }
    },
    data() {
        return { requested: false }
    },
    mounted() {
        this.$emit('update:pin', '')
        if (this.$refs.pin) {
            this.$refs.pin.focus()
        }
    },
    methods: {
        classes(index) {
            return store.getters['classes'](index)
        },
        trans(key) {
            let trans = store.getters.trans(key)
            return trans ? trans : this.$t('front.' + key)
        },
        request() {
            this.requested = true
            this.$emit('request:pin')
        }
    }
}
</script>
